export const LOCALES = {
  RU: 'ru-RU' as LOCALE,
  KZ: 'kz-KZ' as LOCALE
};

export const PREFIXES = {
  [LOCALES.RU]: ['RU', '_ru', 'Ru'],
  [LOCALES.KZ]: ['KZ', '_kz', 'Kz']
};

export type LOCALE = 'ru-RU' | 'kz-KZ';

/**
 * КОД ЯЗЫКА В ТОМ ВИДЕ, В КАКОМ ЕГО ХРАНИТ И ПОНИМАЕТ СЕРВЕР.
 *
 * У платформы ТРИ написания одного и того же языка, и путать их дорого:
 *   * `kz-KZ` — локаль кабинета (react-intl, словари lang/kz, префиксы полей ОСИ вида nameKz);
 *   * `kk`    — код ISO 639-1. На нём говорят i18next и moment ВНУТРИ кабинета, и он же лежит
 *               в users.lang, telegram_chat_langs.lang и requests.lang микросервиса заявок;
 *   * `kz`    — НЕ СУЩЕСТВУЕТ как код языка. Это код СТРАНЫ, и попади он на сервер,
 *               CHECK-ограничение базы отвергло бы значение, а бот искал бы `kk` и не находил.
 *
 * Отсюда две функции ниже: кабинет внутри себя продолжает жить на `kz-KZ` (переписывать
 * 894 ключа и 18 неймспейсов ради этого этапа никто не просил), а на границе с сервером
 * значение переводится в ISO-код ровно в одном месте
 */
export type ServerLang = 'ru' | 'kk';

/** Локаль кабинета -> код для сервера */
export const toServerLang = (locale: LOCALE): ServerLang => (locale === LOCALES.KZ ? 'kk' : 'ru');

/**
 * Код с сервера -> локаль кабинета.
 *
 * Неизвестное значение и null дают null, а НЕ русский: «человек ещё не выбирал язык» и «человек
 * выбрал русский» — разные новости. На первой кабинет обязан оставить то, что показывал
 * (иначе выбор, сделанный до применения миграции, молча заменялся бы русским), на второй —
 * переключиться
 */
export const fromServerLang = (lang: string | null | undefined): LOCALE | null => {
  if (lang === 'kk') return LOCALES.KZ;
  if (lang === 'ru') return LOCALES.RU;
  return null;
};
